require("expose-loader?exposes=$,jQuery!jquery")
require("expose-loader?exposes=Cookies!js-cookie")
require("../modernizer/modernizr")


import isEqual from 'lodash/isEqual';
import merge from 'lodash/merge';
import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';

window._ = {};
window._.isEqual = isEqual;
window._.merge = merge;
window._.throttle = throttle;
window._.debounce = debounce;

require("jquery-mask-plugin")
